import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// scripts/prerender.js writes a crawlable copy of each page's text outside
// #root so a crawler that does not run JS still has something to read. Once
// React has mounted, the real page is on screen and the fallback would be a
// duplicate, so remove it.
document.getElementById('seo-fallback')?.remove();